import { useState } from 'react'
import Hero from '../components/Hero'
import './Contact.css'

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // Handle form submission here
    console.log('Form submitted:', formData)
    // Reset form
    setFormData({ name: '', email: '', message: '' })
    alert('Thank you for your message! We will get back to you soon.')
  }

  return (
    <>
      <Hero 
        title="Contact Us"
        subtitle="We're here to assist with any questions or inquiries you have."
        backgroundImage="/contact/contact.png"
        height="47.8125vh"
      />

      <section>
        <div className="section-header">
          <h2>Reach Out to Us</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <input 
            type="text" 
            name="name" 
            placeholder="Your Name" 
            value={formData.name}
            onChange={handleChange}
            required 
          />
          <input 
            type="email" 
            name="email" 
            placeholder="Your Email" 
            value={formData.email}
            onChange={handleChange}
            required 
          />
          <textarea 
            name="message" 
            rows={5} 
            placeholder="Your Message" 
            value={formData.message}
            onChange={handleChange}
            required 
          />
          <button type="submit">Submit</button>
        </form>
        <div className="contact-info">
          <p><strong>Phone:</strong>1300 029 262</p>
          <p><strong>Email:</strong> contact@adept-services.com.au</p>
          <p><strong>Address:</strong> 5 George Street, North Strathfield NSW 2137</p>
        </div>
      </section>

      <section className="cta-section">
        <h2>Delivering Value Through Solutions and Services</h2>
        <p>Our mission is to deliver value to our clients through innovative solutions and exceptional service. We stand as a trusted partner in your pursuit of excellence.</p>
        <a className="cta-button" href="/careers">Explore Careers</a>
      </section>
    </>
  )
}

export default Contact
